export enum DefectType {
  RMA = "RMA",
  REPAIR = "Repair",
}
